import React, { useState} from 'react';;



function App() {

  const [income2023, setIncome2023] = useState(120000);
  const [income20232, setIncome20232] = useState(120000);
  const [income2024, setIncome2024] = useState(100000);
  const [income20242, setIncome20242] = useState(100000);
  const [income12, setIncome12] = useState(120000);
  const [income122, setIncome122] = useState(120000);
  const [ilemiesiecy,setIlemiesiecy] = useState("9")
  const [ilemiesiecy2,setIlemiesiecy2] = useState("9")
  const [ryczalt, setRyczalt] = useState("zarobki3")
  const [ryczalt2, setRyczalt2] = useState("zarobki3")
  const [jakidochod, setJakiDochod] = useState("KPIR")
  const [jakidochod2, setJakiDochod2] = useState("BRAK")
  const [dochoduop,setDochoduop] = useState(0);
  const [dochoduop2,setDochoduop2] = useState(0);

  const dane = [
    { id: 1, bank: 'ING',  mnoznik: 70.4350 , mnoznik2: 70.4350, mnoznik3: 62.3295, mnoznik4:57.5833 },
    { id: 2, bank: 'Santander', mnoznik: 51.0769, mnoznik2: 25.5384, mnoznik3: 25.5384, mnoznik4:25.5384 },
    { id: 3, bank: 'Velo', mnoznik: 72.0000, mnoznik2: 72.0000, mnoznik3: 58.0000, mnoznik4:45.0000 },
    { id: 4, bank: 'BNP Paribas', mnoznik: 49.5600, mnoznik2: 49.5600, mnoznik3: 47.8421, mnoznik4:40.4200 },
    { id: 5, bank: 'Millennium', mnoznik: 56.3000, mnoznik2: 56.3000, mnoznik3: 54.0000, mnoznik4:42.2000 },
    { id: 6, bank: 'mBank', mnoznik: 66.7700, mnoznik2: 63.8000, mnoznik3: 50.1000, mnoznik4:39.5000 },
    { id: 7, bank: 'PEKAO SA', mnoznik: 68, mnoznik2: 68, mnoznik3: 56.9000, mnoznik4:42.2000 },
    { id: 8, bank: 'Alior Bank', mnoznik: 69.3444, mnoznik2: 69.3444, mnoznik3: 66.4500, mnoznik4:66.1800 },
    { id: 9, bank: 'PKOBP', mnoznik: 67.11, mnoznik2: 67.11, mnoznik3: 52.165, mnoznik4:39.2 },
    //{ id: 10, bank: 'CITI Handlowy', mnoznik: 1, mnoznik2: 1, mnoznik3: 1, mnoznik4:1 },
    { id: 11, bank: 'BOŚ Bank', mnoznik: 61.9987, mnoznik2: 46.6238, mnoznik3: 46.6238, mnoznik4:42.2111 },
 ];

  const handleincome2023Change = (event) => {
    setIncome2023(event.target.value);
  }
  const handleincome2024Change = (event) => {
    setIncome2024(event.target.value);
  }
  const handleincome12Change = (event) => {
    setIncome12(event.target.value);
  }
  const handledochoduop = (event) => {
    setDochoduop(event.target.value);
  }
  const handleincome20232Change = (event) => {
    setIncome20232(event.target.value);
  }
  const handleincome20242Change = (event) => {
    setIncome20242(event.target.value);
  }
  const handleincome122Change = (event) => {
    setIncome122(event.target.value);
  }
  const handledochoduop2 = (event) => {
    setDochoduop2(event.target.value);
  }



function PIT28(props){
  let a = 1;
  let income2023 = props.income2023;
  let income2024 = props.income2024;
  let ilemiesiecy= props.ilemiesiecy;

  if(ilemiesiecy ==="1"){ilemiesiecy = 13}
  if(ilemiesiecy ==="2"){ilemiesiecy = 14}
  if(ilemiesiecy ==="3"){ilemiesiecy = 15}
  if(ilemiesiecy ==="4"){ilemiesiecy = 16}
  if(ilemiesiecy ==="5"){ilemiesiecy = 17}
  if(ilemiesiecy ==="6"){ilemiesiecy = 18}
  if(ilemiesiecy ==="7"){ilemiesiecy = 19}
  if(ilemiesiecy ==="8"){ilemiesiecy = 20}
  if(ilemiesiecy ==="9"){ilemiesiecy = 21}
  if(ilemiesiecy ==="10"){ilemiesiecy = 22}
  if(ilemiesiecy ==="11"){ilemiesiecy = 23}
  //ing 
  if(props.id === 1 && jakidochod === "Ryczałt"){
    if(ryczalt === "zarobki0") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0}//??
    if(ryczalt === "zarobki1") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0}//??
    if(ryczalt === "zarobki2") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.49} //transport 24%
    if(ryczalt === "zarobki3") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.5} 
    if(ryczalt === "zarobki4") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.69}
    if(ryczalt === "zarobki5") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.61}
    if(ryczalt === "zarobki6") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.59}
    if(ryczalt === "zarobki7") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.69}
  }

  if(props.id === 1 && jakidochod ==="KPIR"){
    a = (Number(income2023) + Number(income2024))/ilemiesiecy*0.83; // ing wylicza tak plus minus dobrze
  }
  
  //santader
  if(props.id === 2 && jakidochod === "Ryczałt"){
    if(ryczalt === "zarobki0") {a = Number(income2023)/12 * a * 0.15} //??
    if(ryczalt === "zarobki1") {a = Number(income2023)/12 * a * 0.15} //??
    if(ryczalt === "zarobki2") {a = Number(income2023)/12 * a * 0.2}
    if(ryczalt === "zarobki3") {a = Number(income2023)/12 * a * 0.3} 
    if(ryczalt === "zarobki4") {a = Number(income2023)/12 * a * 0.35}
    if(ryczalt === "zarobki5") {a = Number(income2023)/12 * a * 0.55} //jak wolny zawód to 0.6
    if(ryczalt === "zarobki6") {a = Number(income2023)/12 * a * 0.40}  
    if(ryczalt === "zarobki7") {a = Number(income2023)/12 * a * 0.55}  // jak wolny zawód to 0.6
  }

  
  if(props.id === 2 && jakidochod ==="KPIR"){
    if(income2023/income2024 <= 0.7){            //income2023/income2024 >= 1.3 ){
      a = props.income2023/12 * 0.81;
    }
    if(income2023/income2024 >= 1.3)
      a = props.income2024/props.ilemiesiecy * 0.81;
    if(income2023/income2024 > 0.7 && income2023/income2024 < 1.3){
      a = (Number(income2023) + Number(income2024))/ilemiesiecy*0.81
    }
    }
  

//velo
  if(props.id === 3 && jakidochod === "Ryczałt"){
   if(ryczalt === "zarobki0") {a = (Number(income12)/12) * 0.1}
   if(ryczalt === "zarobki1") {a = (Number(income12)/12) * 0.15}
   if(ryczalt === "zarobki2") {a = (Number(income12)/12) * 0.25}
   if(ryczalt === "zarobki3") {a = (Number(income12)/12) * 0.4} 
   if(ryczalt === "zarobki4") {a = (Number(income12)/12) * 0.7}
   if(ryczalt === "zarobki5") {a = (Number(income12)/12) * 0.7}
   if(ryczalt === "zarobki6") {a = (Number(income12)/12) * 0.7}
   if(ryczalt === "zarobki7") {a = (Number(income12)/12) * 0.8}
  }

  if(props.id === 3 && jakidochod ==="KPIR"){
             
      a = props.income12/12 * 0.6304; //to jest dla liniówki. dla skali jest 6972
    }

  if(props.id === 4){
    a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * 0.35;
   }

   if(props.id === 5){
    if(income2023/12 > income2024/props.ilemiesiecy){
    if(ryczalt === "zarobki0") {a = (props.income2024/props.ilemiesiecy) * a * 0.25}
    if(ryczalt === "zarobki1") {a = (props.income2024/props.ilemiesiecy) * a * 0.25}
    if(ryczalt === "zarobki2") {a = (props.income2024/props.ilemiesiecy) * a * 0.25}
    if(ryczalt === "zarobki3") {a = (props.income2024/props.ilemiesiecy) * a * 0.25} 
    if(ryczalt === "zarobki4") {a = (props.income2024/props.ilemiesiecy) * a * 0.5}
    if(ryczalt === "zarobki5") {a = (props.income2024/props.ilemiesiecy) * a * 0.5}
    if(ryczalt === "zarobki6") {a = (props.income2024/props.ilemiesiecy) * a * 0.25}
    if(ryczalt === "zarobki7") {a = (props.income2024/props.ilemiesiecy) * a * 0.5}
   }
  }
  if(props.id === 5){
    if(income2023/12 <= income2024/props.ilemiesiecy){
    if(ryczalt === "zarobki0") {a = (props.income2024/props.ilemiesiecy) * 0.9 * a * 0.25}
    if(ryczalt === "zarobki1") {a = (props.income2024/props.ilemiesiecy) * 0.9 * a * 0.25}
    if(ryczalt === "zarobki2") {a = (props.income2024/props.ilemiesiecy) * 0.9 * a * 0.25}
    if(ryczalt === "zarobki3") {a = (props.income2024/props.ilemiesiecy) * 0.9 * a * 0.25} 
    if(ryczalt === "zarobki4") {a = (props.income2024/props.ilemiesiecy) * 0.9 * a * 0.5} //do poprawy między 1-13%
    if(ryczalt === "zarobki5") {a = (props.income2024/props.ilemiesiecy) * 0.9 * a * 0.5}
    if(ryczalt === "zarobki6") {a = (props.income2024/props.ilemiesiecy) * 0.9 * a * 0.25}
    if(ryczalt === "zarobki7") {a = (props.income2024/props.ilemiesiecy) * 0.9 * a * 0.5}
   }
  }
  if(jakidochod ==="Ryczałt"){
   if(props.id === 6 && ilemiesiecy <= 4){
    if(ryczalt === "zarobki0") {a = (props.income2023/12) * a * 0.02 * 5}
    if(ryczalt === "zarobki1") {a = (props.income2023/12) * a * 0.03 * 5}
    if(ryczalt === "zarobki2") {a = (props.income2023/12) * a * 0.055 * 5}
    if(ryczalt === "zarobki3") {a = (props.income2023/12) * a * 0.085 * 5} 
    if(ryczalt === "zarobki4") {a = (props.income2023/12) * a * 0.12 * 5}
    if(ryczalt === "zarobki5") {a = (props.income2023/12) * a * 0.14 * 5}
    if(ryczalt === "zarobki6") {a = (props.income2023/12) * a * 0.15 * 5}
    if(ryczalt === "zarobki7") {a = (props.income2023/12) * a * 0.17 * 5}
  
   } 
   if(props.id === 6 && ilemiesiecy >=5){
    if(ryczalt === "zarobki0") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.02 * 5}
    if(ryczalt === "zarobki1") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.03 * 5}
    if(ryczalt === "zarobki2") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.055 * 5}
    if(ryczalt === "zarobki3") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.085 * 5} 
    if(ryczalt === "zarobki4") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.12 * 5}
    if(ryczalt === "zarobki5") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.14 * 5}
    if(ryczalt === "zarobki6") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.15 * 5}
    if(ryczalt === "zarobki7") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * a * 0.17 * 5}
   }
  }

  if(props.id === 6 && jakidochod ==="KPIR"){
             
    a = (Number(income2023) + Number(income2024))/ilemiesiecy*0.81;; //
  }


   if(props.id === 7){
    if(income2023 <= income12){
      a = props.income2023/12 * 0.42;
    } else{
      a = props.income12/12 * 0.42;
    }
   }

   if(props.id === 8){
    a = (income12 - 21500)*0.8/12;
   }

   if(props.id === 9){
    if(ryczalt === "zarobki0") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * 0.486953}
    if(ryczalt === "zarobki1") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * 0.480953}
    if(ryczalt === "zarobki2") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * 0.465953}
    if(ryczalt === "zarobki3") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * 0.59727} 
    if(ryczalt === "zarobki4") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * 0.56927}
    if(ryczalt === "zarobki5") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * 0.622429}
    if(ryczalt === "zarobki6") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * 0.613429}
    if(ryczalt === "zarobki7") {a = ((Number(income2023) + Number(income2024))/ilemiesiecy) * 0.595429}
   }
   if(props.id === 11){
    a = (income2023/12) * 0.5;
   }

   let mnoznik = props.mnoznik;
   let pit28 = a * mnoznik;

    
  return pit28.toFixed();
}

function PIT36(props){
  let pit36 = 1;
  let income2023 = props.income2023;
  let income2024 = props.income2024;
  let income12 = props.income12;
  



  
  if(props.id === 1){

  }
  
  if(props.id === 2){
    
  }

  if(props.id === 3){
    pit36 = (props.income12 - 24000) *0.81/12;
  }

  if(props.id === 6){
    pit36 = (props.income2023 + props.income2024)/ilemiesiecy;
  }

  if(props.id === 7){
    if(props.income2023 >= props.income12){
      pit36 = (Number(props.income12) ) * 0.81/12;
    }
    if(income2023 < income12){
      pit36 = (Number(props.income2023)) * 0.81/12;
    }
  }

  if(props.id === 9){
    pit36 = (props.income2023 + props.income2024)/ilemiesiecy;
  }

  return pit36.toFixed;
}

function UOP(props){
  
  let mnoznik = props.mnoznik;
  let uop = 1;
  //if(props.id >= 1 && props.dochoduop2 === 0){
 //  uop = props.dochoduop * mnoznik ;
 // }
  if(props.id >= 1){
    uop = (Number(props.dochoduop) + Number(props.dochoduop2)) * mnoznik ;
   }

  return uop.toFixed();
}

const td = {
  boxShadow: "0 0 5px rgba(0, 0, 0, 0.15)",
  width: '150px',
  borderRadius: '5px',
}

const td2 = {
  boxShadow: "0 0 5px rgba(0, 0, 0, 0.15)",
  width: '400px',
  borderRadius: '5px',
}

const tr = {
  border: '1px solid black',
  boxShadow: "0 0 5px rgba(0, 0, 0, 0.15)",
  height: '40px',
  textAlign: "center",
  width: '400px',
  borderRadius: '5px',
}



  return (
    <div className="App">
        WIP. v.0.1<br></br>
        
        <table>
          <td style={td2}>
        <select value={jakidochod} onChange={e => setJakiDochod(e.target.value)}>
            <option value="KPIR">KPIR</option>
            <option value="Ryczałt">Ryczałt</option>
            <option value="UOP">UOP</option>
        </select>
      
        {(() => {
        if (jakidochod === "KPIR") {
          return <label>
              <br></br>
           Dochód z PIT2023
           <br></br>
            <input type="number" value={income2023} onChange={handleincome2023Change}/>
            <br></br>
            Dochód za 2024
            <br></br>
            <input type="number" value={income2024} onChange={handleincome2024Change}/>
            <label>Ile rozliczonych miesięcy
          <select value={ilemiesiecy} onChange={e => setIlemiesiecy(e.target.value)}>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
        </select>
        </label>

            <br></br>
            Dochód z ostatnich 12 miesięcy
            <input type="number" value={income12} onChange={handleincome12Change}/>
            </label>;
        } 
        if(jakidochod === "Ryczałt") {
          return <label>
            <br></br>
            Przychód z PIT
            <br></br>
            <input type="number" value={income2023} onChange={handleincome2023Change}/>
            <br></br>
            Przychód za 2024
            <br></br>
            <input type="number" value={income2024} onChange={handleincome2024Change}/>
            <label>Ile rozliczonych miesięcy
          <select value={ilemiesiecy} onChange={e => setIlemiesiecy(e.target.value)}>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
        </select>
        </label>

            <br></br>
            Przychód z ostatnich 12 miesięcy
            <input type="number" value={income12} onChange={handleincome12Change}/>
            <br></br>
            Stawka ryczałtu
          <select value={ryczalt} onChange={e => setRyczalt(e.target.value)}>
            <option value="zarobki0">2%</option>
            <option value="zarobki1">3%</option>
            <option value="zarobki2">5,5%</option>
            <option value="zarobki3">8,5%</option>
            <option value="zarobki4">12%</option>
            <option value="zarobki5">14%</option>
            <option value="zarobki6">15%</option>
            <option value="zarobki7">17%</option>
        </select>
        </label>;
        }
        if(jakidochod === "UOP") {
          return <label>
            <br></br>
            Średnia wpływów za ostatnie 6 miesięcy
            <br></br>
            <input type="number" value={dochoduop} onChange={handledochoduop}/>
            <br></br>


          </label>
        }
      })()}

    
    </td>

    <td style={td2}>
        <select value={jakidochod2} onChange={e => setJakiDochod2(e.target.value)}>
            <option value="BRAK">Brak dochodu</option>
            <option value="KPIR">KPIR</option>
            <option value="Ryczałt">Ryczałt</option>
            <option value="UOP">UOP</option>
        </select>
      
        {(() => {
         if(jakidochod2 === "BRAK"){
          return <td>
            <li>Tutaj można wybrać dochód drugiej osoby lub jako dochód dodatkowy</li>
            <li>Przeliczanie zdolności działa tylko UOP i UOP</li>
            </td>
          
          
          
         }
         if (jakidochod2 === "KPIR") {
          return <label>
              <br></br>
           Dochód z PIT2023
           <br></br>
            <input type="number" value={income20232} onChange={handleincome20232Change}/>
            <br></br>
            Dochód za 2024
            <br></br>
            <input type="number" value={income20242} onChange={handleincome20242Change}/>
            <label>Ile rozliczonych miesięcy
          <select value={ilemiesiecy2} onChange={e => setIlemiesiecy2(e.target.value)}>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
        </select>
        </label>

            <br></br>
            Dochód z ostatnich 12 miesięcy
            <input type="number" value={income122} onChange={handleincome122Change}/>
            </label>;
        } 
        if(jakidochod2 === "Ryczałt") {
          return <label>
            <br></br>
            Przychód z PIT2023
            <br></br>
            <input type="number" value={income20232} onChange={handleincome20232Change}/>
            <br></br>
            Przychód za 2024
            <br></br>
            <input type="number" value={income20242} onChange={handleincome20242Change}/>
            <label>Ile rozliczonych miesięcy
          <select value={ilemiesiecy2} onChange={e => setIlemiesiecy2(e.target.value)}>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
        </select>
        </label>

            <br></br>
            Przychód z ostatnich 12 miesięcy
            <input type="number" value={income122} onChange={handleincome122Change}/>
            <br></br>
            Stawka ryczałtu
          <select value={ryczalt2} onChange={e => setRyczalt2(e.target.value)}>
            <option value="zarobki0">2%</option>
            <option value="zarobki1">3%</option>
            <option value="zarobki2">5,5%</option>
            <option value="zarobki3">8,5%</option>
            <option value="zarobki4">12%</option>
            <option value="zarobki5">14%</option>n
            <option value="zarobki6">15%</option>
            <option value="zarobki7">17%</option>
        </select>
        </label>;
        }
        if(jakidochod2 === "UOP") {
          return <label>
            <br></br>
            Średnia wpływów za ostatnie 6 miesięcy
            <br></br>
            <input type="number" value={dochoduop2} onChange={handledochoduop2}/>
          </label>
        }
      })()}

    
  
    </td>
    </table>
  


    {(() => {
        if (jakidochod === "KPIR" && jakidochod2 ==="BRAK") {
          return  <table>
       <tr style={tr}>
              <th style={td}>Bank</th>  
              <th style={td}>Dochód netto KPIR</th>
              <th style={td}>Zdolność 1 osoba</th>
              <th style={td}>Zdolność 2 osoby</th>
              <th style={td}>Zdolność 2+1</th>
              <th style={td}>Zdolność 2+2</th>
            </tr>
          {dane.map(({id, bank, mnoznik,mnoznik2,mnoznik3,mnoznik4}) => (
         
            <tr style={tr} key={id}>               
                <td style={td}>{bank}</td>
                <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={1}></PIT28>}</td>
                <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik}></PIT28>}</td>
                <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik2}></PIT28>}</td>
                <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik3}></PIT28>}</td>
                <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik4}></PIT28>}</td>
            </tr>
))}
          
        </table>
        } 
        if(jakidochod === "Ryczałt" && jakidochod2 ==="BRAK") {
          return  <table>
           <tr style={tr}>
                  <th style={td}>Bank</th>  
                  <th style={td}>Dochód netto ryczałt</th>
                  <th style={td}>Zdolność 1 osoba</th>
                  <th style={td}>Zdolność 2 osoby</th>
                  <th style={td}>Zdolność 2+1</th>
                  <th style={td}>Zdolność 2+2</th>
                </tr>
              {dane.map(({id, bank, mnoznik,mnoznik2,mnoznik3,mnoznik4}) => (
             
                <tr style={tr} key={id}>               
                    <td style={td}>{bank}</td>
                    <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={1}></PIT28>}</td>
                    <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik}></PIT28>}</td>
                    <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik2}></PIT28>}</td>
                    <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik3}></PIT28>}</td>
                    <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik4}></PIT28>}</td>
                </tr>
    ))}
              
            </table>
        }
        if(jakidochod === "UOP" && jakidochod2 ==="BRAK") {
          return <table>
           <tr style={tr}>
                  <th style={td}>Bank</th>  
                  <th style={td}>Dochód netto</th>
                  <th style={td}>Zdolność 1 osoba</th>
                  <th style={td}>Zdolność 2 osoby</th>
                  <th style={td}>Zdolność 2+1</th>
                  <th style={td}>Zdolność 2+2</th>
                </tr>
              {dane.map(({id, bank, mnoznik,mnoznik2,mnoznik3,mnoznik4}) => (
             
                <tr style={tr} key={id}>               
                    <td style={td}>{bank}</td>
                    <td style={td}>{dochoduop}</td>
                    <td style={td}>{<UOP id={id} dochoduop={dochoduop} dochoduop2={0} mnoznik={mnoznik}></UOP>}</td>
                    <td style={td}>{<UOP id={id} dochoduop={dochoduop} dochoduop2={0} mnoznik={mnoznik2}></UOP>}</td>
                    <td style={td}>{<UOP id={id} dochoduop={dochoduop} dochoduop2={0} mnoznik={mnoznik3}></UOP>}</td>
                    <td style={td}>{<UOP id={id} dochoduop={dochoduop} dochoduop2={0} mnoznik={mnoznik4}></UOP>}</td>
                </tr>
    ))}
              
            </table>
        }
      })()}
  

  {(() => {
        if (jakidochod === "KPIR" && jakidochod2 ==="KPIR") {
          return  <table>
       <tr style={tr}>
              <th style={td}>Bank</th>  
              <th style={td}>Dochód netto KPIR</th>
              <th style={td}>Drugi dochód netto</th>
              <th style={td}>Zdolność 1 osoba</th>
              <th style={td}>Zdolność 2 osoby</th>
              <th style={td}>Zdolność 2+1</th>
              <th style={td}>Zdolność 2+2</th>
            </tr>
          {dane.map(({id, bank, mnoznik,mnoznik2,mnoznik3,mnoznik4}) => (
         
            <tr style={tr} key={id}>               
                <td style={td}>{bank}</td>
                <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={1}></PIT28>}</td>
                <td style={td}>{<PIT28 id={id} income2023={income20232} income2024={income20242} income12={income122} ilemiesiecy={ilemiesiecy2} mnoznik={1}></PIT28>}</td>
                <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik}></PIT28>}</td>
                <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik2}></PIT28>}</td>
                <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik3}></PIT28>}</td>
                <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik4}></PIT28>}</td>
            </tr>
))}
          
        </table>
        } 
        if(jakidochod === "Ryczałt" && jakidochod2 ==="KPIR") {
          return  <table>
           <tr style={tr}>
                  <th style={td}>Bank</th>  
                  <th style={td}>Dochód netto ryczałt</th>
                  <th style={td}>Drugi dochód netto</th>
                  <th style={td}>Zdolność 1 osoba</th>
                  <th style={td}>Zdolność 2 osoby</th>
                  <th style={td}>Zdolność 2+1</th>
                  <th style={td}>Zdolność 2+2</th>
                </tr>
              {dane.map(({id, bank, mnoznik,mnoznik2,mnoznik3,mnoznik4}) => (
             
                <tr style={tr} key={id}>               
                    <td style={td}>{bank}</td>
                    <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={1}></PIT28>}</td>
                    <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik}></PIT28>}</td>
                    <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik2}></PIT28>}</td>
                    <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik3}></PIT28>}</td>
                    <td style={td}>{<PIT28 id={id} income2023={income2023} income2024={income2024} income12={income12} ilemiesiecy={ilemiesiecy} mnoznik={mnoznik4}></PIT28>}</td>
                </tr>
    ))}
              
            </table>
        }
        if(jakidochod === "UOP" && jakidochod2 === "UOP") {
          return <table>
           <tr style={tr}>
                  <th style={td}>Bank</th>  
                  <th style={td}>Dochód netto</th>
                  <th style={td}>Drugi dochód netto</th>
                  <th style={td}>Zdolność 1 osoba</th>
                  <th style={td}>Zdolność 2 osoby</th>
                  <th style={td}>Zdolność 2+1</th>
                  <th style={td}>Zdolność 2+2</th>
                </tr>
              {dane.map(({id, bank, mnoznik,mnoznik2,mnoznik3,mnoznik4}) => (
             
                <tr style={tr} key={id}>               
                    <td style={td}>{bank}</td>
                    <td style={td}>{dochoduop}</td>
                    <td style={td}>{dochoduop2}</td>
                    <td style={td}>{<UOP id={id} dochoduop={dochoduop} dochoduop2={dochoduop2} mnoznik={mnoznik}></UOP>}</td>
                    <td style={td}>{<UOP id={id} dochoduop={dochoduop} dochoduop2={dochoduop2} mnoznik={mnoznik2}></UOP>}</td>
                    <td style={td}>{<UOP id={id} dochoduop={dochoduop} dochoduop2={dochoduop2} mnoznik={mnoznik3}></UOP>}</td>
                    <td style={td}>{<UOP id={id} dochoduop={dochoduop} dochoduop2={dochoduop2} mnoznik={mnoznik4}></UOP>}</td>
                </tr>
    ))}
              
            </table>
        }
      })()}
      <br></br>
<p>Narzędzie powstało jakiś czas temu jako odpowiedź na potrzebę automatycznego przeliczania dochodu z ryczałtu, co wcześniej musiałem robić ręcznie. 
Każdy bank stosuje nieco inne zasady przeliczania, dlatego stworzyłem rozwiązanie, które umożliwia szybkie i konkretne obliczenia po wprowadzeniu kilku danych.
</p>

<p>
Dodatkowo, mając już wyliczony dochód netto, można w przybliżeniu oszacować zdolność kredytową. Niestety ale banki nie udostępniają API, dlatego zastosowałem 
przeliczenie na podstawie proporcji. Choć nie jest to idealne rozwiązanie, pozwala ono określić, na co możemy sobie pozwolić finansowo.
</p>
<p>
Uwzględniłem przeliczenia dla rodzin do czterech osób, ale istnieje możliwość rozbudowy narzędzia o większe rodziny. 
Dodałem także opcję uwzględnienia drugiego dochodu. Na ten moment tylko zestawienie dwóch dochodów z umowy o pracę (UOP + UOP) pozwala na automatyczne obliczenie
 zdolności kredytowej. W innych przypadkach dane należy wprowadzać ręcznie, choć planuję w przyszłości dodać możliwość dowolnych przeliczeń. 
</p>       
       
     
   
    </div>
  
  );
}

export default App;
